import React, { useState } from "react";
import { SKILLS } from "@/lib/portfolioData";
import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";

const groupIcons = {
  Creative: "◐",
  Technical: "◇",
  Marketing: "◈",
};

export default function Skills() {
  const groups = Object.keys(SKILLS);
  const [activeGroup, setActiveGroup] = useState(groups[0]);

  return (
    <section id="skills" className="relative py-24 md:py-36 px-6 md:px-10" data-testid="skills-section">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          number="03"
          tag="Craft"
          title={<>
            The <span className="text-gradient-gold">Skill</span> Set
          </>}
          kicker="Every project brings creative, technical, and marketing chops together — end to end."
        />

        {/* Tabs */}
        <div className="flex flex-wrap gap-2 mb-12" data-testid="skills-tabs">
          {groups.map((g) => (
            <button
              key={g}
              onClick={() => setActiveGroup(g)}
              data-testid={`skill-tab-${g.toLowerCase()}`}
              className={`px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.25em] font-display transition-all duration-300 border ${
                activeGroup === g
                  ? "bg-[#D4AF37] text-black border-[#D4AF37]"
                  : "bg-transparent text-white/70 border-white/10 hover:border-[#D4AF37]/40 hover:text-white"
              }`}
            >
              <span className="mr-2 text-[#D4AF37]">{groupIcons[g]}</span>
              {g}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SKILLS[activeGroup].map((skill, i) => {
            const Icon = skill.icon;
            return (
              <Reveal key={skill.name} delay={i * 60}>
                <div
                  className="group relative overflow-hidden rounded-2xl bg-[#161616] border border-white/5 p-6 h-full raise-hover"
                  data-testid={`skill-card-${skill.name.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_top_right,rgba(212,175,55,0.14),transparent_60%)]" />
                  <div className="relative flex items-start gap-4">
                    <div className="w-11 h-11 rounded-xl bg-[#0A0A0A] border border-[#D4AF37]/25 flex items-center justify-center shrink-0 group-hover:bg-[#D4AF37]/10 transition-colors">
                      <Icon className="w-5 h-5 text-[#D4AF37]" />
                    </div>
                    <div>
                      <h4 className="font-display text-lg text-white mb-1.5">{skill.name}</h4>
                      <p className="text-sm text-[#B3B3B3] leading-relaxed">{skill.desc}</p>
                    </div>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="h-[1px] bg-white/10 flex-1 relative overflow-hidden">
                      <div className="absolute inset-y-0 left-0 w-1/2 bg-[#D4AF37] group-hover:w-full transition-all duration-1000" />
                    </div>
                    <span className="ml-3 text-[10px] uppercase tracking-[0.25em] text-white/40 font-display">
                      0{i + 1}
                    </span>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
